import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export const initIndexRecipeFloat = () => {
  window.addEventListener('load', () => {
    const topNav = document.getElementById('primary-nav-static');
    const filterBars = document.querySelector('#recipe-pin-sidebar');
    const recipeBody = document.querySelector('#recipe-body');

    if (!topNav || !filterBars) {
      return;
    }

    const topNavOffset = topNav.offsetHeight;
    const mm = gsap.matchMedia();

    mm.add('(min-width: 991px)', () => {
      ScrollTrigger.create({
        trigger: recipeBody,
        markers: false,
        start: `top +=${topNavOffset}`,
        end: () => 'bottom bottom',
        pin: filterBars,
        pinSpacing: false,
      });
    });
  });
};

export const initRecipeSmoothScroll = () => {
  const recipeScrollButtons = document.querySelectorAll('.btn-scroll');
  const topNav = document.getElementById('primary-nav-static');

  if (!topNav || !recipeScrollButtons) {
    return;
  }
  window.addEventListener('load', () => {
    recipeScrollButtons?.forEach((recipeScrollButton) => {
      recipeScrollButton.addEventListener('click', () => {
        const id = recipeScrollButton.getAttribute('data-target');
        const target = document.getElementById(id);
        const targetOffset = target.getBoundingClientRect().top;
        const topNavOffset = topNav.offsetHeight;
        const currentPos = window.scrollY;
        const topOffset = targetOffset + currentPos - topNavOffset;

        window.scroll({
          behavior: 'smooth',
          top: topOffset,
        });
      });
    });
  });
};
